export default __webpack_public_path__ + "static/media/lucky-charm.7a69a85f.webp";